import React from 'react';

/** @internal */
export var plusIconElement = /*#__PURE__*/React.createElement("svg", {
  width: "25",
  height: "25",
  viewBox: "0 0 25 25",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("rect", {
  x: "11.8008",
  y: "4",
  width: "1.4",
  height: "17",
  rx: "0.7"
}), /*#__PURE__*/React.createElement("rect", {
  x: "4",
  y: "11.7998",
  width: "17",
  height: "1.4",
  rx: "0.7"
}));